import { useTranslation } from "react-i18next";
import ContentLayout from "@cloudscape-design/components/content-layout";
import Container from "@cloudscape-design/components/container";
import Header from "@cloudscape-design/components/header";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Link from "@cloudscape-design/components/link";
import Box from "@cloudscape-design/components/box";
import ColumnLayout from "@cloudscape-design/components/column-layout";

function HomeView({ onNavigate }) {
  const { t } = useTranslation();

  return (
    <ContentLayout
      header={<Header variant="h1">{t("home.overview.title")}</Header>}
    >
      <SpaceBetween size="l">
        <Container>
          <Box variant="p">{t("home.overview.description")}</Box>
          <Box variant="p" margin={{ top: "s" }}>{t("home.overview.cta_prefix")}{" "}<Link href="#/scenarios" onFollow={(e) => { e.preventDefault(); onNavigate("scenarios"); }}>{t("home.overview.cta_link")}</Link>{t("home.overview.cta_suffix")}</Box>
        </Container>

        <ColumnLayout columns={3}>
          <div style={{ height: "100%" }}>
            <Container fitHeight header={<Header variant="h2"><span style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}><img src="/nova-sonic-icon.svg" alt="" style={{ height: "36px" }} />{t("home.nova-sonic.title")}</span></Header>}>
              <Box variant="p">{t("home.nova-sonic.description")}</Box>
            </Container>
          </div>
          <div style={{ height: "100%" }}>
            <Container fitHeight header={<Header variant="h2"><span style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}><img src="/agentcore-icon.svg" alt="" style={{ height: "36px" }} />{t("home.agentcore.title")}</span></Header>}>
              <Box variant="p">{t("home.agentcore.description")}</Box>
            </Container>
          </div>
          <div style={{ height: "100%" }}>
            <Container fitHeight header={<Header variant="h2"><span style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}><img src="/bedrock-icon.png" alt="" style={{ height: "36px" }} />{t("home.bedrock.title")}</span></Header>}>
              <Box variant="p">{t("home.bedrock.description")}</Box>
            </Container>
          </div>
        </ColumnLayout>

        <Container
          header={
            <Header
              variant="h2"
              description={t("home.architecture.description")}
            >
              {t("home.architecture.title")}
            </Header>
          }
        >
          <Box textAlign="center">
            <img
            src="/architecture.png"
            alt={t("home.architecture.alt_text")}
            style={{ width: "100%", maxWidth: "600px", maxHeight: "600px", objectFit: "contain" }}
          />
          </Box>
        </Container>

        <Container
          header={
            <Header
              variant="h2"
              description={t("home.resources.description")}
            >
              {t("home.resources.title")}
            </Header>
          }
        >
          <SpaceBetween size="l">
            <SpaceBetween size="xs">
              <Link
                external={true}
                href="https://gitlab.aws.dev/mkhs/nova-sonic-isv-demo-scenario"
              >
                {t("home.resources.repo_label")}
              </Link>
              <Box variant="p">{t("home.resources.repo_description")}</Box>
            </SpaceBetween>
            <SpaceBetween size="xs">
              <Link
                external={true}
                href="https://amazon.enterprise.slack.com/archives/C0AJUF2KL5V"
              >
                {t("home.resources.slack_label")}
              </Link>
              <Box variant="p">{t("home.resources.slack_description")}</Box>
            </SpaceBetween>
          </SpaceBetween>
        </Container>
      </SpaceBetween>
    </ContentLayout>
  );
}

export default HomeView;
